import { defineStore } from "pinia";
import type { SelectType } from "@/models/enum/selectType";
import { industries } from "@/modules/industries";
import { organisationForms } from "@/modules/organisationForms";
import { getCountries } from "@/services/countriesService";
import type { Country } from "@/models/country";
import {
  countries as countryList,
  countriesWithChineseRegions,
} from "@/modules/countries";
import { nationalities } from "@/modules/nationalities";

export interface IItemsState {
  Datamap: Record<SelectType, string[]>;
  countries: Array<Country>;
  dialCodes: Array<string>;
  countryNames: Array<string>;
  countryCodes: Array<string>;
}

export const useItemsStore = defineStore("items", {
  state: (): IItemsState => ({
    Datamap: {} as Record<SelectType, string[]>,
    countries: new Array<Country>(),
    dialCodes: new Array<string>(),
    countryNames: new Array<string>(),
    countryCodes: new Array<string>(),
  }),
  actions: {
    async setItems() {
      try {
        const countriesList = await this.setCountries();

        this.countries = countriesList;
        this.countryNames = countriesList.map((c) => c.name);
        this.countryCodes = countriesList.map((c) => c.code);

        this.dialCodes = new Array<string>(
          ...new Map<string, string>(
            countriesList.map((c) => [c.dialCode, c.dialCode])
          ).values()
        ).sort((c1, c2) => Number(c1) - Number(c2));
      } catch (error) {
        this.countries = new Array<Country>();
        this.dialCodes = new Array<string>();
        this.countryNames = new Array<string>();
        this.countryCodes = new Array<string>();
      } finally {
        this.Datamap = {
          Countries: this.countryNames,
          Industries: industries,
          OrganisationForms: organisationForms,
          Nationalities: nationalities,
          CountriesWithChineseRegions: countriesWithChineseRegions,
        };
      }
    },

    async setCountries(): Promise<Country[]> {
      if (this.countries.length == 0) {
        const response = await getCountries();
        const allCountries = new Map<string, string>(Object.entries(response));
        const countriesList = countryList.filter((c) =>
          allCountries.has(c.code)
        );

        return countriesList;
      } else {
        return this.countries;
      }
    },
  },
});
